import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import apiRequest from "../API_Service/AxiosConfiguration";
import { APIURL } from "../Common/APIURL";

export const EmailConfig_CreateUpdateEmailTemplate = createAsyncThunk(
  "emailTemplate/save",
  async (payload, { rejectWithValue }) => {
    try {
      const { CompanyId, ...body } = payload;
      const res = await apiRequest(
        "post",
        `${APIURL}EmailTemplate/SaveEmailTemplate?CompanyId=${CompanyId}`,
        body,
      );
      return res;
    } catch (err) {
      return rejectWithValue(err?.response?.data ?? err.message);
    }
  },
);

export const EmailConfig_DeleteEmailTemplate = createAsyncThunk(
  "emailTemplate/delete",
  async ({ id, modifiedBy }, { rejectWithValue }) => {
    try {
      const res = await apiRequest(
        "delete",
        `${APIURL}EmailTemplate/DeleteEmailTemplate?id=${id}&modifiedBy=${modifiedBy}`,
      );
      return res;
    } catch (err) {
      return rejectWithValue(err?.response?.data ?? err.message);
    }
  },
);

export const EmailConfig_GetModuleFunctionalityList = createAsyncThunk(
  "emailTemplate/getModuleFunctionality",
  async ({ moduleID, templateID = 0, companyId }, { rejectWithValue }) => {
    try {
      const res = await apiRequest(
        "get",
        `${APIURL}EmailTemplate/GetModuleFunctionalityList?moduleID=${moduleID}&templateID=${templateID}&companyId=${companyId}`,
      );
      return res;
    } catch (err) {
      return rejectWithValue(err?.response?.data ?? err.message);
    }
  },
);

export const EmailConfig_GetTemplateColumnByIDs = createAsyncThunk(
  "emailTemplate/getTemplateColumns",
  async ({ moduleFunctionID, companyId }, { rejectWithValue }) => {
    try {
      const res = await apiRequest(
        "get",
        `${APIURL}EmailTemplate/GetTemplateColumnByIDs?moduleFunctionID=${moduleFunctionID}&companyId=${companyId}`,
      );
      return res;
    } catch (err) {
      return rejectWithValue(err?.response?.data ?? err.message);
    }
  },
);

export const EmailConfig_GetDataForModuleList = createAsyncThunk(
  "emailTemplate/getModuleList",
  async ({ moduleID, companyId }, { rejectWithValue }) => {
    try {
      const res = await apiRequest(
        "get",
        `${APIURL}EmailTemplate/GetDataForModuleList?moduleID=${moduleID}&companyId=${companyId}`,
      );
      return res;
    } catch (err) {
      return rejectWithValue(err?.response?.data ?? err.message);
    }
  },
);

export const EmailConfig_GetEmailTemplateList = createAsyncThunk(
  "emailTemplate/getList",
  async ({ companyId }, { rejectWithValue }) => {
    try {
      const res = await apiRequest(
        "get",
        `${APIURL}EmailTemplate/EmailTempList?companyId=${companyId}`,
      );
      return res;
    } catch (err) {
      return rejectWithValue(err?.response?.data ?? err.message);
    }
  },
);

export const EmailConfig_GetEmailTemplateByID = createAsyncThunk(
  "emailTemplate/getByID",
  async ({ id }, { rejectWithValue }) => {
    try {
      const res = await apiRequest(
        "get",
        `${APIURL}EmailTemplate/EmailTempListByID?id=${id}`,
      );
      return res;
    } catch (err) {
      return rejectWithValue(err?.response?.data ?? err.message);
    }
  },
);

export const EmailConfig_SaveEmailLog = createAsyncThunk(
  "emailTemplate/saveLog",
  async ({ emailLog, companyId }, { rejectWithValue }) => {
    try {
      const res = await apiRequest(
        "post",
        `${APIURL}EmailTemplate/SaveEmailLog?companyId=${companyId}`,
        emailLog,
      );
      return res;
    } catch (err) {
      return rejectWithValue(err?.response?.data ?? err.message);
    }
  },
);

export const EmailConfig_SaveEmailTemplateStatus = createAsyncThunk(
  "emailTemplate/saveStatus",
  async ({ emailTemplateId, status, companyId }, { rejectWithValue }) => {
    try {
      const res = await apiRequest(
        "post",
        `${APIURL}EmailTemplate/SaveEmailTemplateStatus?emailTemplateId=${emailTemplateId}&status=${status}&companyId=${companyId}`,
      );
      return res;
    } catch (err) {
      return rejectWithValue(err?.response?.data ?? err.message);
    }
  },
);

const emailTemplateSlice = createSlice({
  name: "emailTemplate",
  initialState: {
    list: [],
    currentItem: null,
    isLoading: false,
    error: null,
  },
  reducers: {
    clearEmailTemplateState: (state) => {
      state.currentItem = null;
      state.error = null;
    },
    // Optimistic status toggle
    updateTemplateStatusOptimistic: (state, action) => {
      const { emailTemplateId, isActive } = action.payload;
      state.list = state.list.map((item) =>
        item.EmailTemplateID === emailTemplateId
          ? { ...item, IsActive: isActive }
          : item,
      );
    },
  },
  extraReducers: (builder) => {
    // Get list
    builder
      .addCase(EmailConfig_GetEmailTemplateList.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(EmailConfig_GetEmailTemplateList.fulfilled, (state, action) => {
        state.isLoading = false;
        const d = action.payload?.data ?? action.payload;
        state.list = Array.isArray(d) ? d : [];
      })
      .addCase(EmailConfig_GetEmailTemplateList.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });

    // Get by ID
    builder.addCase(
      EmailConfig_GetEmailTemplateByID.fulfilled,
      (state, action) => {
        state.currentItem = action.payload?.data ?? action.payload ?? null;
      },
    );

    // Save
    builder
      .addCase(EmailConfig_CreateUpdateEmailTemplate.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(EmailConfig_CreateUpdateEmailTemplate.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(
        EmailConfig_CreateUpdateEmailTemplate.rejected,
        (state, action) => {
          state.isLoading = false;
          state.error = action.payload;
        },
      );
  },
});

export const { clearEmailTemplateState, updateTemplateStatusOptimistic } =
  emailTemplateSlice.actions;

export default emailTemplateSlice.reducer;
